import type { ReportDocument } from "../../services/report";
import { StatusIcon } from "../StatusIcon";
import { reportWarningsOf, type ReportSectionKey } from "./reportFormat";

// The REVIEW_REQUIRED report warnings of one section (backend/app/services/report.py): a value
// the stored run does not carry, named on the sheet in the server's own words instead of being
// invented. Rendered inside the section the value belongs to, as review-tone cards in the
// vocabulary of every warning panel; nothing when the section has none.

type ReportWarningNotesProps = {
  document: ReportDocument;
  section: ReportSectionKey;
};

export function ReportWarningNotes({ document, section }: ReportWarningNotesProps) {
  const warnings = reportWarningsOf(document, section);
  if (warnings.length === 0) {
    return null;
  }
  return (
    <ul data-report-warnings={section} data-warning-count={warnings.length}>
      {warnings.map((warning, index) => (
        <li key={`${warning.code}-${index}`} data-warning-code={warning.code} data-warning-tone="review">
          <strong>
            <StatusIcon tone="review" size={16} />
            {warning.code}
          </strong>
          {": "}
          <span>{warning.message}</span>
          <span>{` (${warning.status})`}</span>
        </li>
      ))}
    </ul>
  );
}

export default ReportWarningNotes;
